import { render } from "./addPrograms.vue?vue&type=template&id=ed41390a&scoped=true"
import script from "./addPrograms.vue?vue&type=script&lang=js"
export * from "./addPrograms.vue?vue&type=script&lang=js"

import "./addPrograms.vue?vue&type=style&index=0&id=ed41390a&scoped=true&lang=css"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed41390a"]])

export default __exports__